import { render } from "./AdminFeriados.vue?vue&type=template&id=27418cce&scoped=true"
import script from "./AdminFeriados.vue?vue&type=script&lang=js"
export * from "./AdminFeriados.vue?vue&type=script&lang=js"

import "./AdminFeriados.vue?vue&type=style&index=0&id=27418cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27418cce"]])

export default __exports__